import styled from 'styled-components'

import { CssUnit } from '@/types'
import { fontSizes, fontWeights } from '@/styles'
import { toUnit } from '@/utils/styles'

type TitleProps = {
  weight?: number | string
  mBottom?: CssUnit
  mTop?: CssUnit
}

const ModalTitle = styled.h2<TitleProps>`
  font-family: Inter, sans-serif;
  font-weight: ${fontWeights.medium};
  font-size: ${fontSizes.medium};
  line-height: 27px;
  margin: 0;
  text-align: center;
  font-weight: ${props => props.weight};
  ${props =>
    props.mBottom &&
    `
    margin-bottom: ${toUnit(props.mBottom)};
  `}
  ${props =>
    props.mTop &&
    `
    margin-top: ${toUnit(props.mTop)};
  `}
`

ModalTitle.defaultProps = {
  weight: 600,
  mBottom: 0,
  mTop: 0
}

export default ModalTitle
